import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=29b8bb1e&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b8bb1e",
  null
  
)

export default component.exports